export const FACEBOOK_FEED_ENABLED = window.FACEBOOK_FEED?.enabled || false;
export const FACEBOOK_FEED_DEPRECATED = window.FACEBOOK_FEED?.deprecated || false;

export const FACEBOOK_FEED_HEIGHT = 700;
export const FACEBOOK_FEED_HEIGHT_TO_WIDTH_RATIO = 1.4;
export const FACEBOOK_FEED_SCREEN_HEIGHT_MAX_QUOTA = 0.8;

// FACEBOOK PLUGIN VALUES
export const FACEBOOK_FEED_DEFAULT_HEIGHT = 500;
export const FACEBOOK_FEED_DEFAULT_WIDTH = 340;
export const FACEBOOK_FEED_MAX_WIDTH = 500;
export const FACEBOOK_FEED_MIN_WIDTH = 180;
